import { getAnonId, getUserAccountId } from '../../utilities/getUserCookieValues/getUserCookieValues';
import { JimdoApp } from './types';
import { createURL } from './utilities';

export const STAGE_URL = 'https://feature-flags-proxy.stage.jimdo.systems';
export const PROD_URL = 'https://feature-flags-proxy.prod.jimdo.systems';

/**
 * we need to wrap the creation of BASE_URL in a function for ssr applications.
 * On server side rendering, there is no window available.
 * The function `fetchExperiments` is called in a `useEffect` and therefore not evaluated
 * during the server side rendering and therefore no errors for `window is not defined` will happen anymore
 * If we don't do this, BASE_URL would be created on import and on ssr `window` is not available at that time.
 */
let BASE_URL = '';
const getBaseUrl = () => {
  if (BASE_URL) {
    return BASE_URL;
  }
  const isProd = window.location.host.includes('jimdo.com');
  BASE_URL = isProd ? PROD_URL : STAGE_URL;
  return BASE_URL;
};

const fetchRequest = (url: string) =>
  fetch(url).then((response) => {
    if (response.status !== 200) {
      return response.text().then((errorDescription) => {
        throw new Error(errorDescription);
      });
    }
    return response.json();
  });

export interface Args {
  country?: string;
  language?: string;
  email?: string;
  isMobileLayout?: boolean;
  jimdoApp: JimdoApp;
  isAffiliate: boolean;
  dateJoined?: string;
}

export const fetchExperiments = ({
  country,
  language,
  email,
  isMobileLayout,
  jimdoApp,
  isAffiliate,
  dateJoined,
}: Args) => {
  try {
    const userAccountId = getUserAccountId();
    const shd = getAnonId();
    if (!userAccountId && !shd) {
      // TODO handle error. what would happen to crawlers without any cookies?
    }

    const url = createURL(`${getBaseUrl()}/feature-flags`, {
      userAccountId,
      shd,
      country,
      email,
      originalValues: 'true',
      custom: JSON.stringify({
        language: language?.substr(0, 2).toLocaleLowerCase(),
        isMobileLayout,
        jimdoApp,
        isAffiliate,
        dateJoined,
      }),
    });

    return fetchRequest(url);
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(`${e.name}: ${e.message}`);
    } else if (
      typeof e === 'string' ||
      typeof e === 'number' ||
      typeof e === 'boolean' ||
      e instanceof String ||
      e instanceof Number ||
      e instanceof Boolean
    ) {
      throw new Error(e.toString());
    } else {
      throw e;
    }
  }
};
